import { IconButton, createStyles, makeStyles, Theme } from "@material-ui/core";
import ArrowIcon from '@material-ui/icons/ArrowBackIos';

type Param = {
    onClick: () => void
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        //minWidth: 50,
        borderRadius: 0,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: theme.palette.secondary.main,
        backgroundColor: 'rgba(255, 255, 255, .2)',
    },

    endIcon: {
        position: 'relative',
        left: 3
    }

}));

const BtnNavBack: React.FC<Param> = ({ onClick }) => {
    const classes = useStyles();

    return <>
        <IconButton
            onClick={onClick}
            classes={{ root: classes.root }}
            style={{ marginRight: 10 }}
            color='secondary'
        >

            <ArrowIcon fontSize="small" className={classes.endIcon} />
        </IconButton >
    </>
        ;
}

export default BtnNavBack;